import React, { useState, useEffect } from 'react'
import _ from 'lodash'

import {
  useAnalyticsContext,
  AnalyticsProvider,
} from '../Providers/AnalyticsProvider'
import { getEmbedThemeInfo, getEmbedExperienceText } from '../theme/Loader'

// import './external-link.css'

const ExternalLink = () => {
  const { createUser, dispatchAnalyticsEvent } = useAnalyticsContext()
  const [sessionToken, setSessionToken] = useState(
    sessionStorage.getItem('fk-impact-okta-auth') || ''
  )
  useEffect(() => {
    if (sessionToken) {
      createUser(sessionToken)
    }
    window.addEventListener('onImpactStorageChange', onSessionChange)
    return () => {
      window.removeEventListener('onImpactStorageChange', onSessionChange)
    }
    // eslint-disable-next-line
  }, [])

  const onSessionChange = () => {
    const newSessiontoken = sessionStorage.getItem('fk-impact-okta-auth') || ''
    console.log('session updated: ', newSessiontoken)
    if (newSessiontoken) {
      createUser(newSessiontoken)
    }
    setSessionToken(newSessiontoken)
  }

  const openLink = (token) => {
    const themeConfig = getEmbedThemeInfo()
    token && dispatchAnalyticsEvent('CREATE_STORY_CLICK', { session: token })
    const url = _.get(themeConfig, 'external_link', '')
    // console.log(`${url}?accessToken=${token}`)
    return window.open(`${url}?accessToken=${token}`)
  }

  const isAuthenticated = !!sessionToken
  const btnTitle = getEmbedExperienceText('external-link', 'btn-title')
  return (
    <div
      className={`external-link ${isAuthenticated ? '' : 'disable'}`}
      onClick={isAuthenticated ? () => openLink(sessionToken) : undefined}
    >
      {btnTitle}
    </div>
  )
}

export default () => {
  return (
    <AnalyticsProvider widget="create-story-link">
      <ExternalLink />
    </AnalyticsProvider>
  )
}
